import { derived } from "svelte/store";
import { teamStore } from "../../../../api-stores/license-store";
import { StagingStore } from "../../../../stores/staging-store";
import { getContext, setContext } from "svelte";

let CTX = Symbol("inbox-agent-admin-context");

export const getInboxAgentAdminContext = () => {
  const ctx = getContext(CTX);
  if (!ctx) {
    throw new Error(
      "Inbox Agent Admin Context not found. Did you call createInboxAgentAdminContext?",
    );
  }
  return ctx;
};

export const createInboxAgentAdminContext = () => {
  teamStore.once();

  const aiDraftFAQStore = new StagingStore({
    store: derived(teamStore, ($teamStore) => {
      const defaults = {};
      const faq = $teamStore["ai-replies-faq"] || JSON.stringify(defaults);
      try {
        return JSON.parse(faq);
      } catch {
        return defaults;
      }
    }),
  });
  const ctx = {
    aiDraftFAQStore,
  };
  setContext(CTX, ctx);
  return ctx;
};
